import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './services/auth/service/auth.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'admin-management';
  apiUrl = environment.apiUrl;
  isLoading: boolean = false;
  showProgress: boolean = false

  constructor(private authService: AuthService, @Inject(PLATFORM_ID) private platformId: Object, public router: Router,private cdr: ChangeDetectorRef) {}

  isLoginRoute(): boolean {
    return this.router.url === '/login';
  }

  private handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      console.log('Tab ist wieder aktiv!');
      this.onTabActivated();
    }
  }

  ngOnInit() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  ngOnDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  onTabActivated() {
    this.authService.visibilitySessionCheck()
  }

  // private visibilityChangeHandler = () => this.checkSessionOnVisible();

  // ngOnInit(): void {
  //   if (this.apiUrl !== 'https://dev.api.tridimo.de/api/' && isPlatformBrowser(this.platformId)) {
  //     this.checkSession();
  //     document.addEventListener('visibilitychange', this.visibilityChangeHandler);
  //   }
  // }

  // ngOnDestroy(): void {
  //   if (isPlatformBrowser(this.platformId)) {
  //     document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
  //   }
  // }

  // private checkSessionOnVisible(): void {
  //   if (isPlatformBrowser(this.platformId) && document.visibilityState === 'visible') {
  //     this.checkSession();
  //   }
  // }

  // private checkSession(): void {
  //   this.authService.visibilitySessionCheck().subscribe({
  //     next: () => {
  //       // Benutzer ist eingeloggt – keine Aktion nötig
  //     },
  //     error: (err) => {
  //       // console.error('Session-Fehler:', err);
  //     },
  //   });
  // }
}
